interface iConfig extends Window {
    configs: {[key: string]: string} | undefined
}

declare const window: iConfig;

export default function getEnv(name: string): string | undefined {
    return window?.configs?.[name] || process.env[name]
}